import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { toggleModal, toggleSnackBar, toggleSpinner } from 'apps/auth/actions/appAction';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { Text } from 'apps/auth/components/common/Text/Text';
import { AUTH_SEND } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';

import { BannerCloseButton, BannerContainer, BannerSubtitle } from '../../paysendPlus/styles';

const Sun25PromoCampaignBanner = (props) => {
    const { bannerSun25Title, bannerSun25Text } = usePageMessages();
    const [bannerShow, setBannerShow] = useState(false);

    useEffect(() => {
        let bannerHalloween25Show = localStorage.getItem('bannerHalloween25Show');
        if ((bannerHalloween25Show && bannerHalloween25Show !== 'false') || !bannerHalloween25Show) {
            setBannerShow(true);
        }
    }, [bannerShow]);

    const onClose = (e) => {
        e.stopPropagation();
        localStorage.setItem('bannerHalloween25Show', 'false');

        setBannerShow(false);
    };

    return (
        bannerShow && (
            <BannerContainer
                onClick={async () => {
                    props.toggleSpinner(true);
                    window.location.href = AUTH_SEND;
                }}
            >
                <BannerCloseButton>
                    <DiskButton size="small" iconName="cross" iconColor="white_base" type="button" variant="glass" onClick={onClose} />
                </BannerCloseButton>
                <div>
                    <Text variant="div" color="white_base" indent="8px" size="main">
                        {bannerSun25Title}
                    </Text>
                    <BannerSubtitle>
                        <Text variant="div" color="white_base" size="secondary" indent="16px">
                            {bannerSun25Text}
                        </Text>
                    </BannerSubtitle>
                </div>
            </BannerContainer>
        )
    );
};
export default connect(null, { toggleModal, toggleSpinner, toggleSnackBar })(Sun25PromoCampaignBanner);
